import React, { useState, useEffect } from 'react';
import './sales.css';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ContextMenu from "../../components/ContextMenu/ContextMenu";
import Header from "../../components/Header/Header";
import SalesHeader from "../../components/PagesHeaders/SalesHeader/SalesHeader";
import Pagination from "../../components/Pagination/Pagination";
import {
    changePaymentDateSagaAction,
    getSalesSagaAction,
    removePaymentSagaAction
} from "../../redux/sagaActions";
import PaymentForm from "../../components/PaymentForm/PaymentForm";
import { contextAction, paymentFormAction } from "../../redux/rootReducer";
import CalendarOffline from "../../components/CalendarOffline/CalendarOffline";
import Tippy from '@tippyjs/react';

const Sales = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const sales = useSelector(state => state.sales);
    const all_sales_count = useSelector(state => state.all_sales_count);
    const total_sum = useSelector(state => state.total_sum);
    const filterDate = useSelector(state => state.filterDate);
    const filterUser = useSelector(state => state.filterUser);
    const context = useSelector(state => state.context);
    const filterTypesOptions = useSelector(state => state.filterTypesOptions);
    const filterCoachesOptions = useSelector(state => state.filterCoachesOptions);
    const filterSubjectOptions = useSelector(state => state.filterSubjectOptions);
    const filterPaymentMethodsOptions = useSelector(state => state.filterPaymentMethodsOptions);
    const filterAdminsOptions = useSelector(state => state.filterAdminsOptions);
    const filterMinSum = useSelector(state => state.filterMinSum);
    const filterMaxSum = useSelector(state => state.filterMaxSum);

    // Состояние открытого календаря
    const [changePaymentDateCalendar, setChangePaymentDateCalendar] = useState(null);

    let data = null;
    if (sales?.length  && context) {
        data = sales.find(elem => elem.id === context);
    }

    const menu = [
        {
            id: '1',
            caption: 'Редактировать',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                dispatch(paymentFormAction({
                    open: true,
                    id: data.id,
                    payment: [{ index: 1, cost: data.cost, payment_method: { id: data.payment_id, name: data.payment_type }}],
                    discount: data?.discount?.id ? data.discount : { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: +data.cost * 100 / (100 - +data.discount.percent),
                    date: data.date_not_formatted
                }))
            }
        },
        {
            id: '2',
            caption: 'Удалить',
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                // Подтверждение удаления платежа
                if (window.confirm('Вы действительно хотите удалить указанный платёж?')) {
                    dispatch(removePaymentSagaAction({ payment_id: data.id, with_subject: 0 }));
                }
            }
        },
        {
            id: '3',
            caption: data?.remove_btn,
            handler: () => {
                // Убираем контекстное меню
                dispatch(contextAction(false));
                if (data.remove && window.confirm(data.remove)) {
                    dispatch(removePaymentSagaAction({ payment_id: data.id, with_subject: 1 }));
                }
            }
        }
    ];

    // Функция смены страницы
    const changePage = page => {
        dispatch(getSalesSagaAction({
            page,
            from: filterDate.from,
            to: filterDate.to,
            subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
            subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
            sales_type: JSON.stringify(filterSubjectOptions.filter(el => el.active).map(el => el.id)),
            payment_methods: JSON.stringify(filterPaymentMethodsOptions.filter(el => el.active).map(el => el.id)),
            admins: JSON.stringify(filterAdminsOptions.filter(el => el.active).map(el => el.id)),
            minSum: filterMinSum,
            maxSum: filterMaxSum,
            sales_user: filterUser.user.id
        }));
    };

    // Получение списка продаж
    useEffect(() => {

        if (!currentEstablishment) return;

        dispatch(getSalesSagaAction({ page: 1 }));
    }, [currentEstablishment]);

    return (
        <>
            <Header component={ <SalesHeader/> }/>
            <div className="page">
                <PaymentForm/>
                <div className="page__content">
                    <div className="table__header">
                        <div className="sales__count">
                            <div className="sales__count-item">{ `Всего продаж: ${ all_sales_count }` }</div>
                            <div className="sales__count-item">{ `На сумму: ${ total_sum } руб.` }</div>
                        </div>
                        <div className="table__caption sales__caption">Продажи</div>
                    </div>
                    <div className="table">
                        <div className="table__row table__row--header sales__row">
                            <div className="table__cell table__cell--left">Имя</div>
                            <div className="table__cell">Тип тренировки</div>
                            <div className="table__cell">Занятия (шт.)</div>
                            <div className="table__cell">Товар</div>
                            <div className="table__cell">Дата оплаты</div>
                            <div className="table__cell">Тренер</div>
                            <div className="table__cell">Стоимость</div>
                            <div className="table__cell">Тип оплаты</div>
                            <div className="table__cell">Скидка</div>
                            <div className="table__cell">Админ</div>
                            <div className="table__cell"/>
                        </div>
                        {
                            sales.map(elem => {
                                return (
                                    <div key={ elem.id } className="table__row sales__row">
                                        <ContextMenu data={{
                                            open: elem.id === context,
                                            style: { right: 28 },
                                            menu
                                        }}/>
                                        {
                                            elem.promo_code && <Tippy content={ `Промокод: ${ elem.promo_code }` }>
                                                <i className="sales__promo-code"/>
                                            </Tippy>
                                        }
                                        <div className="table__cell table__cell--left table__cell--hover"
                                            onClick={ () => {
                                                if (!elem.user_id) return;

                                                // Переходим в карточку клиента
                                                history.push('/fitness/users/' + elem.user_id);
                                            } }
                                        >
                                            { elem.user }
                                            {
                                                elem.user &&
                                                <Tippy content={ 'Открыть в новой вкладке' }>
                                                    <div className="user__tab"
                                                         onClick={ event => {
                                                             event.preventDefault();
                                                             event.stopPropagation();

                                                             window.open('/fitness/users/' + elem.user_id, '_blank', 'noopener,noreferrer');
                                                         } }
                                                    />
                                                </Tippy>
                                            }
                                        </div>
                                        <div className="table__cell">{ elem.type }</div>
                                        <div className="table__cell">{ elem.workouts_count }</div>
                                        <div className="table__cell">{ elem.goods_name }</div>
                                        <div className="table__cell table__cell--hover table__cell--no-overflow"
                                            onClick={ event => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                if (event.target.closest('.calend')) return;
                                                setChangePaymentDateCalendar(elem.id);
                                            } }
                                        >
                                            { elem.buy_date }
                                            <CalendarOffline
                                                date={ elem.date_not_formatted }
                                                handler={ date => {
                                                    setChangePaymentDateCalendar(null);
                                                    dispatch(changePaymentDateSagaAction({
                                                        payment_id: elem.id,
                                                        date
                                                    }));
                                                } }
                                                open={ changePaymentDateCalendar === elem.id }
                                                close={ () => setChangePaymentDateCalendar(null) }
                                            />
                                        </div>
                                        <div className="table__cell">{ elem.coach }</div>
                                        <div className={ `table__cell ${ elem.cost < 0 ? 'table__cell--inactive' : '' }` }>{ elem.cost }</div>
                                        <div className="table__cell">{ elem.payment_type }</div>
                                        <div className="table__cell">{ elem.discount.name }</div>
                                        <div className="table__cell">{ elem.admin }</div>
                                        <i className="menu__button"
                                            onClick={ () => dispatch(contextAction(elem.id)) }
                                        />
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <Pagination handler={ changePage }/>
            </div>
        </>
    );
};

export default Sales;